import { useTransitionStyles } from '@floating-ui/react';
function getHorizontalTransformOrigin(placement) {
    if (placement.includes('start')) {
        return 'left';
    }
    if (placement.includes('end')) {
        return 'right';
    }
    return 'center';
}
function getVerticalTransformOrigin(placement) {
    if (placement.includes('start')) {
        return 'top';
    }
    if (placement.includes('end')) {
        return 'bottom';
    }
    return 'center';
}
/**
 * Common hook to get custom transition styles for popover-like components.
 */
export function useFloatingTransitionStyles(context, placement, duration) {
    return useTransitionStyles(context, {
        duration,
        initial: {
            opacity: 0,
            transform: 'scale(0.7)',
        },
        common: ({ side }) => ({
            transformOrigin: {
                top: `bottom ${getHorizontalTransformOrigin(placement)}`,
                bottom: `top ${getHorizontalTransformOrigin(placement)}`,
                left: `${getVerticalTransformOrigin(placement)} right`,
                right: `${getVerticalTransformOrigin(placement)} left`,
            }[side],
        }),
    });
}
